<template>
  <div class="card">
    <div class="card-body">
      <b-row>
        <b-col cols="8">
          <h4 class="card-title">{{$t('order.uren')}}</h4>
        </b-col>
        <b-col cols="4">
          <div class="pull-right">
            <b-button v-b-modal.modalOrderTimes variant="themecolor" size="sm" @click.stop="loadModal(null)">{{$t('buttons.toevoegen')}}</b-button>
          </div>
        </b-col>
      </b-row>
      <b-table show-empty 
               :items="orderTimes" 
               :fields="fields" 
               v-if="orderTimes" 
               class="lines-table"
               :empty-text="getEmptyText(count)"
               :busy="count == -1" 
               foot-clone>
        <template v-slot:cell(user)="data">{{data.item.user.fullName}}</template>
        <template v-slot:cell(date)="data">{{data.item.startTime | date}}</template>
        <template v-slot:cell(startTime)="data">{{data.item.startTime | time}}</template>
        <template v-slot:cell(endTime)="data">{{data.item.endTime | time}}</template>
        <template v-slot:cell(actions)="row">
          <b-button v-b-modal.modalOrderTimes variant="themecolor" size="sm" @click.stop="loadModal(row.item)">
            <i class="fa fa-edit" aria-hidden="true"></i>
          </b-button>
          <delete title="Urenregel" :noRedirect="true" :hideText="true" :id="row.item.id" namespace="comceptum" resource="ordertimes"/>
        </template>
        <template v-slot:foot(user)="">
          <span>&nbsp;</span>
        </template>
        <template v-slot:foot(date)="">
          <span>&nbsp;</span>
        </template>
        <template v-slot:foot(startTime)="">
          <span>&nbsp;</span>
        </template>
        <template v-slot:foot(endTime)="">
          <strong>{{$t('klanten.totaal')}}:</strong>
        </template>
        <template v-slot:foot(actions)="">
          {{totalDurationInSeconds}}
        </template>
        <template v-slot:table-busy>
          <PreLoader/>
        </template>        
      </b-table>
    </div>
    <!-- Modal Component -->
    <b-modal
      id="modalOrderTimes"
      ref="orderTimesModal"
      :title="`${$t('order.uren')} ${command.id ? $t('buttons.bewerken') : $t('buttons.toevoegen')}`"
      hide-footer
      centered
      :cancel-title="$t('buttons.annuleren')"
      ok-variant="themecolor"
      :ok-title="$t('buttons.opslaan')"
    >
      <b-form @submit="onSubmit" autocomplete="off">
        <!-- Form content -->
        <b-form-group v-if="!command.id" label-cols :label="$t('datatables.gebruiker')">
          <b-form-select v-model="command.userId">
            <option value>--- {{$t('order.maakeenkeuze')}} ---</option>
            <option v-for="item in users" v-bind:key="item.id" :value="item.id">{{ item.fullName }}</option>
          </b-form-select>
          <validation element="user_id" :message="$t('validatie.geefeengebruikerop')"/>
        </b-form-group>
        <b-form-group label-cols :label="$t('datatables.datum')">
          <datepicker class="form-control" v-model="date" placeholder="dd-mm-yyyy"/>
        </b-form-group>
        <b-form-group label-cols :label="$t('order.tijdvan')">
          <vue-timepicker v-model="startTime" :format="timeFormat" :minute-interval="5" />
          <validation element="start_time"/>
        </b-form-group>
        <b-form-group label-cols :label="$t('order.tijdtot')">
          <vue-timepicker v-model="endTime" :format="timeFormat" :minute-interval="5" />
        </b-form-group>
        <!-- Form content -->
        <hr>
        <!-- Submit controls -->
        <b-row>
          <b-col md="12">
            <b-button @click="$refs.orderTimesModal.hide()" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
            <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
          </b-col>
        </b-row>
        <!-- Submit controls -->
      </b-form>
    </b-modal>
    <!-- Modal Component -->
  </div>
</template>
<script>
//Import store
import { mapGetters, mapActions } from "vuex";

//Import command
import Command from "./command";

import moment from "moment";
import VueTimepicker from 'vuejs-timepicker'

import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

export default {
  name: "times",
  data() {
    return {
      command: new Command(),
      date: moment().format("YYYY-MM-DD"),
      timeFormat: 'HH:mm',
      startTime: { 
         HH: moment().format("HH").toString(),
         mm: "00"
      },
      endTime: {
        HH: moment().add(1, "hours").format("HH"),
        mm: "00"
      },
      count: -1,
    };
  },
  components: {
    VueTimepicker,
    PreLoader
  },
  computed: {
    fields() {
      return [
        { key: "user", label: this.$i18n.t('datatables.medewerker'), sortable: true },
        { key: "date", label: this.$i18n.t('datatables.datum'), sortable: true },
        { key: "startTime", label: this.$i18n.t('datatables.start'), sortable: true },
        { key: "endTime", label: this.$i18n.t('datatables.eind'), sortable: true },
        { key: "actions", label: this.$i18n.t('datatables.acties') }
      ]
    },
    ...mapGetters("comceptum", ["orderTimes"]),
    ...mapGetters("core", ["users"]),
    ...mapGetters("profile", ["userId"]),
    totalDurationInSeconds: function() {
      var totalDuration = this.orderTimes
        .map(x => x.durationInMinutes)
        .reduce((a, b) => a + b, 0);

      return parseFloat(totalDuration / 60).toFixed(2) + " uur";
    }
  },
  methods: {
    ...mapActions("comceptum", ["all", "create", "update", "delete"]),
    loadModal(item) {
      var vm = this;
      vm.$store.dispatch("errors/clearErrors");
         
      vm.command = new Command(item);
            
      vm.command.workOrderId = vm.$route.params.workOrderId;
      vm.command.userId = vm.userId;
      
      if (vm.command.id) {
        let startTime = vm.$options.filters
          .time(vm.command.startTime)
          .split(":");
        let endTime = vm.$options.filters.time(vm.command.endTime).split(":");
        vm.date = vm.$options.filters.formatDateTime(
          vm.command.startTime,
          "YYYY-MM-DD"
        );
        vm.startTime = { HH: startTime[0], mm: startTime[1] };
        vm.endTime = { HH: endTime[0], mm: endTime[1] };
      }
    },
    onSubmit(event) {
      event.preventDefault();

      var vm = this;
      let date = vm.$options.filters.formatDateTime(vm.date, "YYYY-MM-DD");
      vm.command.startTime = moment(`${date} ${vm.startTime.HH}:${vm.startTime.mm}:00`).format();
      vm.command.endTime = moment(`${date} ${vm.endTime.HH}:${vm.endTime.mm}:00`).format();

      var payload = { resource: "ordertimes", params: vm.command };

      var action = vm.command.id ? vm.update(payload) : vm.create(payload);

      action.then(() => {
        vm.$refs.orderTimesModal.hide();
      });
    },
    getEmptyText,
  },
  created() {
    var vm = this;
    vm.all({
      resource: "ordertimes"
    })
    .then((data) => {
      vm.count = data.result.length;
    });

    vm.$store.dispatch("core/all", {
      resource: "users"
    });
  }
};
</script>